import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

/**
 * Message-history skeleton (SPEC-2026-07-internal-chat, T-25 · RNF-08).
 *
 * Alternating inbound/outbound placeholder bubbles for the conversation pane
 * while the first history page is in flight (RNF-02 target is 800 ms, so this
 * is short-lived but avoids an empty white pane). Bootstrap `.placeholder`
 * utilities only.
 */
@Component({
  selector: 'chat-message-list-skeleton',
  templateUrl: './chat-message-list-skeleton.component.html',
  styleUrls: ['./chat-skeleton.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ChatMessageListSkeletonComponent implements OnInit {

  /** How many placeholder bubbles to render. */
  @Input() rows = 6;

  /** Compact spacing for the popup (390px wide) surface. */
  @Input() compact = false;

  /** Built once — the row count never changes while the skeleton is mounted. */
  rowList: number[] = [];

  ngOnInit(): void {
    const total = Math.max(1, Math.min(this.rows, 20));
    this.rowList = Array.from({ length: total }, (_unused, index) => index);
  }
}
